// extracted by mini-css-extract-plugin
export default {"icon":"N8sBFS","rounded-icon":"LMWnWA","roundedIcon":"LMWnWA"};